import PropTypes from 'prop-types'
import React from 'react'

const AccountIcon = ({
   className,
   color,
   width,
   height
}) => (
   <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 24 24">
      <g
         className={className}
         fill={color}>
         <path
            fill={color}
            d="M12,0C5.383,0,0,5.383,0,12s5.383,12,12,12s12-5.383,12-12S18.617,0,12,0z M18.698,19.404 C18.034,17.431,16.198,16,14,16h-4c-2.198,0-4.032,1.432-4.696,3.405C3.281,17.574,2,14.937,2,12C2,6.486,6.486,2,12,2 s10,4.486,10,10C22,14.936,20.72,17.573,18.698,19.404z"
         />
         <path
            d="M12,5C9.791,5,8,6.791,8,9v1c0,2.209,1.791,4,4,4s4-1.791,4-4V9C16,6.791,14.209,5,12,5z"
         />
      </g>
   </svg>
)

AccountIcon.propTypes = {
   className: PropTypes.string,
   color: PropTypes.string,
   height: PropTypes.string,
   width: PropTypes.string
}

AccountIcon.defaultProps = {
   className: undefined,
   color: '#444',
   height: '24px',
   width: '24px'
}

export default React.memo(AccountIcon)
